import styled from 'styled-components';
import { motion } from 'framer-motion';
import { PrimaryColor, SecondaryColor } from '../utils/StyleVariables';

export const WhatsappHeader = styled.div`
    min-height: 150px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 120px;
    background-color: #f9f9f9;


    .lottie-spotlight {
        width: 60%;
    }
    

      input{
        &.invalid {
            border: 1px solid #B9150A;
            box-shadow: 0px 0px 5px 0px #B9150A;
          }
        
      }
    
      label{
        color: ${SecondaryColor};
        font-size: 14px;
      }
    
      .form-control:focus {
        border-color: #00B759 !important;
      }
      
      form span {
        color: #B9150A;
        font-size: 15px;
      }
    
      .form-check-input:checked {
        border-color: ${PrimaryColor} !important;
        background-color: ${PrimaryColor} !important;
      }
      

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const WhatsappNumbersStyles = styled.div`
    gap: 250px;

      @media (max-width: 1300px) {
        gap: 50px;
    }
`;

export const WhatsappVideo = styled.div`
    min-height: 150px;
    display: grid;
    grid-template-columns: repeat(1, 1fr); 
     /* background-color: #f9f9f9; */
     gap: 30px;
    padding: 50px 90px;
    padding-bottom: 70px;


    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
         padding: 0;
    padding-bottom: 70px;
    }

      @media (min-width: 1201px) and (max-width: 1500px) {
     padding: 0;
      padding-bottom: 70px;
  }
`;

export const WhatsappText = styled.div`
  .green-check-list li {
  margin-bottom: 10px;
  list-style: none;
}

.green-check-list li::before {
  content: '✔';
  color: #00a651;
  font-weight: bold;
  margin-right: 10px;

}
  
`;

export const BookButtonStyles = styled.div`

  margin-top: 38px;


  .slice {
   padding: 12px 30px;
   text-decoration: none;
   background-color: ${PrimaryColor};
   border: 1px solid ${PrimaryColor};
   border-radius: 10px;
   cursor: pointer;
   overflow: hidden;
   position: relative;
   transition: 300ms cubic-bezier(0.83, 0, 0.17, 1);

  & > .text {
    font-weight: 700;
    padding: 0;
    margin: 0;
    color: rgba(255,255,255,0.6);
    position: relative;
   font-size: 16px;
   text-transform: uppercase;

    z-index: 1;
    transition: color 700ms cubic-bezier(0.83, 0, 0.17, 1);
  }
}

.slice::after {
  content: "";
  width: 0;
  height: calc(300% + 1em);
  position: absolute;
  translate: -50% -50%;
  inset: 50%;
  rotate: 30deg;
  background-color: #006432;
  transition: 1000ms cubic-bezier(0.83, 0, 0.17, 1);
}

.slice:hover {
  & > .text {
    color: rgba(255,255,255,0.6);
  }
  &::after {
    width: calc(120% + 1em);
  }

   box-shadow: 0 10px 20px rgba(0 , 166 , 81, 0.4);
}

.slice:active {
  scale: 0.98;
  filter: brightness(0.9);
}

`;

export const VideoStyles = styled.div`
  /* background-color: rgba(0 , 166 , 81, 0.7); */
  background-color:#A2FFCF;

  video{
    height: 440px;
    width: 560px;

  }

   @media screen and (max-width: 479px) {
  video{
        height: 216px;
        width: 290px;


  }
  }

  @media (min-width: 480px) and (max-width: 768px) {
    video{
      height:250px;
        width: 320px;

    }
  }

  @media (min-width: 769px) and (max-width: 1250px) {
    video{
      height: 350px;
    width: 450px;

    }
  }

  
`;

export const VideoCardDiv = styled(motion.div)`
  width: 75%;

  @media screen and (max-width: 768px) {
    width: 95%;
  }

    @media (min-width: 769px) and (max-width: 1500px) {
    width: 85%;
  }
`;
